import {http} from '@/http/index.js';

async function getGirlProfile(girlId) {
  return http.get(`/girls/${girlId}`).then((response) => response.data.data);
}

export {getGirlProfile};
